import styled from 'styled-components';
import { Layout } from 'antd';
import { ButtonAnt } from '@/components/buttons/button/ButtonAnt';

export const StyledButtonAnt = styled(ButtonAnt)``;

export const StyledHeader = styled(Layout.Header)`
  &.ant-layout-header {
    background-color: ${({ theme }) => theme.color.grey.grey11};
    height: 48px;
    line-height: 40px;
    color: ${({ theme }) => theme.color.grey.white};
    padding: 0 24px;
    z-index: 1000;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: 0 16px;
  }

  ${StyledButtonAnt} {
    color: ${({ theme }) => theme.colors.white};
    min-width: 48px;
    height: 48px;
    padding: 0 16px;

    i {
      font-size: 18px;
    }
  }

  img {
    margin-right: 16px;
  }
`;
